/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function replaceAll(subject, search, replace = "") {
    //Note for now we work only with strings. If it is needed with Arrays enhance the method!
    if (typeof subject !== "string") return null;
    if (!search) return subject;
    let result = subject;
    while (result.includes(search)) {
        result = result.replace(search, replace);
    }
    return result;
}
